export const initialCart = {
  products: [],
  shippingFee: 0,
  shippingFeeCap: 0,
};
